import React, {Component} from  "react";
import { connect } from "react-redux";
import Draggable from '../utils/draggable'
import {Icon, Tooltip} from 'antd'
import { updateAppClosedStatus } from '../../action/morpheus.state.action'

import "../../asset/style/utils/app.css"

class App extends Component {
    constructor(props) {
        super(props);

        let closed = this.props.defaultClosed === undefined ? true : this.props.defaultClosed;
        this.props.dispatch(updateAppClosedStatus(this.props.appKey.id, closed));
    }

    closeApp = () => {
        this.props.dispatch(updateAppClosedStatus(this.props.appKey.id, true));
    }

    render(){
        let app = undefined;
        let title = this.props.appKey.showTitle ? this.props.appKey.title : '';

        app = <div style={(this.props.appState[this.props.appKey.id] || {}).closed ? {display: "none"} : {}}>
                <Draggable
                    id={this.props.appKey.id}
                    startBottom={this.props.startBottom}
                    startLeft={this.props.startLeft}
                    startTop={this.props.startTop}
                    startRight={this.props.startRight}
                    content={
                        <div 
                            id={this.props.id}
                            className={"closeable"}>
                            <div 
                                className="closeable-handle" 
                                onClick={this.closeApp}>
                                <Tooltip 
                                    title="Click to Close"
                                    placement="right"
                                    mouseLeaveDelay={0}
                                    overlayStyle={{
                                        fontSize:"10px"
                                    }}>
                                    <Icon className="close-icon" type="close-circle" theme="twoTone" twoToneColor="#de2323"/>   
                                </Tooltip> 
                            </div>
                            <div className="app-title">{title}</div>
                            {this.props.content}
                        </div>
                    } />
                </div>

        return app;
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
      appState: state.viewerUrlReducer.app_state
  };
};

export default connect(mapStateToProps)(App);